import { render } from "./CardImage.vue?vue&type=template&id=1952da6a&scoped=true&ts=true"
import script from "./CardImage.vue?vue&type=script&lang=ts"
export * from "./CardImage.vue?vue&type=script&lang=ts"

import "./CardImage.vue?vue&type=style&index=0&id=1952da6a&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1952da6a"]])

export default __exports__